import Select from "react-select";

export default function OverlaySelector({
    overlays,
    selectedOverlays,
    onChange,
}) {
    const options = overlays.map((overlay) => ({
        value: overlay,
        label: overlay,
    }));
    const selectedOptions = selectedOverlays.map((overlay) => ({
        value: overlay,
        label: overlay,
    }));

    return (
        <div className="flex-grow-1" style={{ minWidth: 0 }}>
            <Select
                isMulti
                options={options}
                value={selectedOptions}
                onChange={(newSelectedOverlays) =>
                    onChange(
                        (newSelectedOverlays || []).map(
                            (overlay) => overlay.value,
                        ),
                    )
                }
                placeholder={"Select overlay..."}
            />
        </div>
    );
}
